import { toConsole, printf, toText } from "./fable_modules/fable-library.3.7.12/String.js";
import { oneOf, str, stringParam, s, map, custom, customParam } from "./fable_modules/Fable.Elmish.Browser.3.0.4/parser.fs.js";
import { some, bind } from "./fable_modules/fable-library.3.7.12/Option.js";
import { tryParse } from "./fable_modules/fable-library.3.7.12/Guid.js";
import { FSharpRef } from "./fable_modules/fable-library.3.7.12/Types.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.3.7.12/Choice.js";
import { pageHash, Page, AuthPage, AuthPage_get_tryParse } from "./Pages.js";
import { Result_ofOption } from "./fable_modules/AsyncResult.0.3.0/Result.fs.js";
import { singleton, ofArray, collect } from "./fable_modules/fable-library.3.7.12/List.js";
import { Navigation_newUrl, Navigation_modifyUrl } from "./fable_modules/Fable.Elmish.Browser.3.0.4/navigation.fs.js";
import { Msg, Model } from "./Types.js";
import { Cmd_map, Cmd_batch, Cmd_none } from "./fable_modules/Fable.Elmish.3.1.0/cmd.fs.js";
import { Security_EmailChangeViewModel, Security_ResetPasswordViewModel } from "./fable_modules/Webbler.Models.1.2.6/Api.fs.js";
import { Model as Model_1 } from "./Auth/AuthTypes.js";
import { Model as Model_2 } from "./TelepathologyGuest/TelepathologyGuestTypes.js";
import { init } from "./Sites/SitesState.js";
import { Cmd_OfFunc_result } from "./fable_modules/Fable.Elmish.3.1.0/cmd.fs.js";
import { Msg as Msg_1 } from "./Sites/SitesTypes.js";
import { init as init_1 } from "./Patients/PatientSearchState.js";
import { Msg as Msg_2 } from "./Patients/PatientSearchTypes.js";
import { init as init_2 } from "./InForm/InFormState.js";
import { Msg as Msg_3 } from "./InForm/InFormTypes.js";
import { equals } from "./fable_modules/fable-library.3.7.12/Util.js";
import { SessionManagement_SessionManagementModel__get_token } from "./Session.js";

export function parseUrls(page) {
    if (page.tag === 1) {
        if (page.fields[0] == null) {
            return "guest";
        }
        else {
            const token_2 = page.fields[0];
            return toText(printf("%s?token=%s"))("guest")(token_2);
        }
    }
    else if (page.tag === 2) {
        return "accounts";
    }
    else if (page.tag === 5) {
        return "devices";
    }
    else if (page.tag === 6) {
        if (page.fields[0] == null) {
            return "patientSearch";
        }
        else if (page.fields[1] != null) {
            const patientId = page.fields[0];
            const sessionId = page.fields[1];
            return `${"patientSearch"}/${patientId}/details/${sessionId}`;
        }
        else {
            const patientId_1 = page.fields[0];
            return `${"patientSearch"}/${patientId_1}`;
        }
    }
    else if (page.tag === 7) {
        if (page.fields[0] == null) {
            return "inForm";
        }
        else {
            const thingName = page.fields[0];
            return `${"inForm"}/${thingName}`;
        }
    }
    else if (page.tag === 3) {
        return toText(printf("%s/%O/%s"))("accounts")(page.fields[0])("sites");
    }
    else if (page.tag === 4) {
        return "authorizedSites";
    }
    else if (page.tag === 8) {
        return "users";
    }
    else if (page.tag === 9) {
        return "userProfile";
    }
    else if (page.tag === 10) {
        return "dashboard";
    }
    else {
        let arg20_2;
        const _arg1 = page.fields[0];
        let pattern_matching_result, token, currEmail, newEmail, token_1;
        if (_arg1.tag === 1) {
            if (_arg1.fields[0] == null) {
                pattern_matching_result = 2;
            }
            else {
                pattern_matching_result = 1;
                token = _arg1.fields[0];
            }
        }
        else if (_arg1.tag === 3) {
            pattern_matching_result = 3;
        }
        else if (_arg1.tag === 4) {
            pattern_matching_result = 4;
        }
        else if (_arg1.tag === 2) {
            if (_arg1.fields[0] != null) {
                if (_arg1.fields[1] != null) {
                    if (_arg1.fields[2] != null) {
                        pattern_matching_result = 5;
                        currEmail = _arg1.fields[0];
                        newEmail = _arg1.fields[1];
                        token_1 = _arg1.fields[2];
                    }
                    else {
                        pattern_matching_result = 6;
                    }
                }
                else {
                    pattern_matching_result = 6;
                }
            }
            else {
                pattern_matching_result = 6;
            }
        }
        else {
            pattern_matching_result = 0;
        }
        switch (pattern_matching_result) {
            case 0: {
                arg20_2 = "login";
                break;
            }
            case 1: {
                arg20_2 = toText(printf("%s?token=%s"))("resetPassword")(token);
                break;
            }
            case 2: {
                arg20_2 = "resetPassword";
                break;
            }
            case 3: {
                arg20_2 = "requestPasswordReset";
                break;
            }
            case 4: {
                arg20_2 = "register";
                break;
            }
            case 5: {
                arg20_2 = toText(printf("%s?currEmail=%s\u0026newEmail=%s\u0026token=%s"))("emailChange")(currEmail)(newEmail)(token_1);
                break;
            }
            case 6: {
                arg20_2 = "emailChange";
                break;
            }
        }
        return toText(printf("%s/%s"))("auth")(arg20_2);
    }
}

function guidParam(key, chunks) {
    return customParam(key, (option) => bind((arg) => {
        let _arg1;
        let outArg = "00000000-0000-0000-0000-000000000000";
        _arg1 = [tryParse(arg, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        if (_arg1[0]) {
            return _arg1[1];
        }
        else {
            return void 0;
        }
    }, option))(chunks);
}

function guidOption(chunks) {
    return custom("guid", (arg) => {
        let _arg1;
        let outArg = "00000000-0000-0000-0000-000000000000";
        _arg1 = [tryParse(arg, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        return _arg1[0] ? (new FSharpResult$2(0, _arg1[1])) : (new FSharpResult$2(0, void 0));
    })(chunks);
}

function guid(chunks) {
    return custom("guid", (arg) => {
        let _arg1;
        let outArg = "00000000-0000-0000-0000-000000000000";
        _arg1 = [tryParse(arg, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        return _arg1[0] ? (new FSharpResult$2(0, _arg1[1])) : (new FSharpResult$2(1, void 0));
    })(chunks);
}

function auth(chunks) {
    let f1;
    return custom("auth", (f1 = AuthPage_get_tryParse(), (arg) => Result_ofOption(void 0, f1(arg))))(chunks);
}

export const pageParser = (() => {
    let parser, parseBefore, parseAfter, queryParser, parser_6, parser_4, parser_2, parseBefore_2, parseAfter_2, queryParser_2, queryParser_4, queryParser_6, parseBefore_4, parser_8, queryParser_8, parseBefore_8, parseBefore_6, parseAfter_8, parser_10, parseBefore_10, parseBefore_16, parseBefore_14, parseBefore_12, parseAfter_14, parseBefore_18;
    const parsers = ofArray([map((arg) => (new Page(0, new AuthPage(1, arg))), (parser = ((parseBefore = s("auth"), (parseAfter = s("resetPassword"), (state) => collect(parseAfter, parseBefore(state))))), (queryParser = stringParam("token"), (state_2) => collect(queryParser, parser(state_2))))), map((a) => ((b) => ((c) => ((arg_1) => {
        let tupledArg;
        return new Page(0, (tupledArg = arg_1, new AuthPage(2, tupledArg[0], tupledArg[1], tupledArg[2])));
    })([a, b, c]))), (parser_6 = ((parser_4 = ((parser_2 = ((parseBefore_2 = s("auth"), (parseAfter_2 = s("emailChange"), (state_4) => collect(parseAfter_2, parseBefore_2(state_4))))), (queryParser_2 = stringParam("currEmail"), (state_6) => collect(queryParser_2, parser_2(state_6))))), (queryParser_4 = stringParam("newEmail"), (state_8) => collect(queryParser_4, parser_4(state_8))))), (queryParser_6 = stringParam("token"), (state_10) => collect(queryParser_6, parser_6(state_10))))), map((arg0_4) => (new Page(0, arg0_4)), (parseBefore_4 = s("auth"), (state_12) => collect(auth, parseBefore_4(state_12)))), map((arg0_5) => (new Page(1, arg0_5)), (parser_8 = s("guest"), (queryParser_8 = stringParam("token"), (state_14) => collect(queryParser_8, parser_8(state_14))))), map(new Page(2), s("accounts")), map((arg0_6) => (new Page(3, arg0_6)), (parseBefore_8 = ((parseBefore_6 = s("accounts"), (state_16) => collect(guid, parseBefore_6(state_16)))), (parseAfter_8 = s("sites"), (state_18) => collect(parseAfter_8, parseBefore_8(state_18))))), map(new Page(4), s("authorizedSites")), map(new Page(5), s("devices")), map((a_2) => ((b_2) => {
        const tupledArg_1 = [a_2, b_2];
        return new Page(6, tupledArg_1[0], tupledArg_1[1]);
    }), (parser_10 = ((parseBefore_10 = s("patientSearch"), (state_20) => collect(guidOption, parseBefore_10(state_20)))), (state_22) => collect((chunks_3) => guidParam("noop", chunks_3), parser_10(state_22)))), map((a_4) => ((b_4) => {
        const tupledArg_2 = [a_4, b_4];
        return new Page(6, tupledArg_2[0], tupledArg_2[1]);
    }), (parseBefore_16 = ((parseBefore_14 = ((parseBefore_12 = s("patientSearch"), (state_24) => collect(guidOption, parseBefore_12(state_24)))), (parseAfter_14 = s("details"), (state_26) => collect(parseAfter_14, parseBefore_14(state_26))))), (state_28) => collect(guidOption, parseBefore_16(state_28)))), map(new Page(6, void 0, void 0), s("patientSearch")), map((arg_2) => (new Page(7, arg_2)), (parseBefore_18 = s("inForm"), (state_31) => collect(str, parseBefore_18(state_31)))), map(new Page(7, void 0), s("inForm")), map(new Page(8), s("users")), map(new Page(9), s("userProfile")), map(new Page(10), s("dashboard"))]);
    return (state_33) => oneOf(parsers, state_33);
})();

export function handleUpdatedUrl(nextPage, model) {
    let inputRecord, inputRecord_1, inputRecord_2, model_1, page_7, page_5, maybeSessionId, maybePatientId, page_3, accountId, page, page_1;
    console.log(some(toText(printf("Parsed page %O"))(nextPage)));
    let pattern_matching_result, token, maybeCurrentEmail, maybeNewEmail, maybeToken, maybeCode, page_2;
    if (nextPage != null) {
        if (nextPage.tag === 0) {
            if (nextPage.fields[0].tag === 1) {
                pattern_matching_result = 1;
                token = nextPage.fields[0].fields[0];
            }
            else if (nextPage.fields[0].tag === 2) {
                pattern_matching_result = 2;
                maybeCurrentEmail = nextPage.fields[0].fields[0];
                maybeNewEmail = nextPage.fields[0].fields[1];
                maybeToken = nextPage.fields[0].fields[2];
            }
            else if ((page = nextPage, ((!equals(page, new Page(0, new AuthPage(4)))) && (!equals(page, new Page(0, new AuthPage(3))))) && (SessionManagement_SessionManagementModel__get_token(model.AuthModel.SessionManagement) == null))) {
                pattern_matching_result = 4;
                page_2 = nextPage;
            }
            else {
                pattern_matching_result = 5;
            }
        }
        else if (nextPage.tag === 1) {
            pattern_matching_result = 3;
            maybeCode = nextPage.fields[0];
        }
        else if ((page_1 = nextPage, ((!equals(page_1, new Page(0, new AuthPage(4)))) && (!equals(page_1, new Page(0, new AuthPage(3))))) && (SessionManagement_SessionManagementModel__get_token(model.AuthModel.SessionManagement) == null))) {
            pattern_matching_result = 4;
            page_2 = nextPage;
        }
        else {
            pattern_matching_result = 5;
        }
    }
    else {
        pattern_matching_result = 0;
    }
    switch (pattern_matching_result) {
        case 0: {
            return [model, Navigation_modifyUrl(pageHash(model.CurrentPage))];
        }
        case 1: {
            if (token == null) {
                return [new Model(model.NotificationsModel, new Page(0, new AuthPage(1, token)), model.RedirectPage, model.AuthModel, model.TelepathologyGuestModel, model.UsersModel, model.AccountsModel, model.SitesModel, model.AuthorizedSitesModel, model.DevicesModel, model.PatientSearchModel, model.InFormModel, model.UserProfileModel, model.DashboardModel, model.MenuIsDefaultCollapsed, model.MenuIsExpanded, model.S3Context, model.AwsToken, model.S3Configuration, model.Credentials), Cmd_none()];
            }
            else {
                return [new Model(model.NotificationsModel, new Page(0, new AuthPage(1, token)), model.RedirectPage, (inputRecord = model.AuthModel, new Model_1(inputRecord.LoginVM, inputRecord.RegisterVM, (inputRecord_1 = model.AuthModel.ResetVM, new Security_ResetPasswordViewModel(inputRecord_1.email, token, inputRecord_1.newPassword, inputRecord_1.confirmPassword)), inputRecord.EmailChangeVm, inputRecord.ResetRequestEmail, inputRecord.UserInfo, inputRecord.SessionManagement, inputRecord.HideResetEmail, inputRecord.Inactivity)), model.TelepathologyGuestModel, model.UsersModel, model.AccountsModel, model.SitesModel, model.AuthorizedSitesModel, model.DevicesModel, model.PatientSearchModel, model.InFormModel, model.UserProfileModel, model.DashboardModel, model.MenuIsDefaultCollapsed, model.MenuIsExpanded, model.S3Context, model.AwsToken, model.S3Configuration, model.Credentials), Cmd_none()];
            }
        }
        case 2: {
            const matchValue = [maybeCurrentEmail, maybeNewEmail, maybeToken];
            let pattern_matching_result_1, changeToken, currentEmail, newEmail;
            if (matchValue[0] != null) {
                if (matchValue[1] != null) {
                    if (matchValue[2] != null) {
                        pattern_matching_result_1 = 0;
                        changeToken = matchValue[2];
                        currentEmail = matchValue[0];
                        newEmail = matchValue[1];
                    }
                    else {
                        pattern_matching_result_1 = 1;
                    }
                }
                else {
                    pattern_matching_result_1 = 1;
                }
            }
            else {
                pattern_matching_result_1 = 1;
            }
            switch (pattern_matching_result_1) {
                case 0: {
                    return [new Model(model.NotificationsModel, new Page(0, new AuthPage(2, maybeCurrentEmail, maybeNewEmail, maybeToken)), model.RedirectPage, (inputRecord_2 = model.AuthModel, new Model_1(inputRecord_2.LoginVM, inputRecord_2.RegisterVM, inputRecord_2.ResetVM, new Security_EmailChangeViewModel(currentEmail, newEmail, changeToken), inputRecord_2.ResetRequestEmail, inputRecord_2.UserInfo, inputRecord_2.SessionManagement, inputRecord_2.HideResetEmail, inputRecord_2.Inactivity)), model.TelepathologyGuestModel, model.UsersModel, model.AccountsModel, model.SitesModel, model.AuthorizedSitesModel, model.DevicesModel, model.PatientSearchModel, model.InFormModel, model.UserProfileModel, model.DashboardModel, model.MenuIsDefaultCollapsed, model.MenuIsExpanded, model.S3Context, model.AwsToken, model.S3Configuration, model.Credentials), Cmd_none()];
                }
                case 1: {
                    return [new Model(model.NotificationsModel, new Page(0, new AuthPage(2, maybeCurrentEmail, maybeNewEmail, maybeToken)), model.RedirectPage, model.AuthModel, model.TelepathologyGuestModel, model.UsersModel, model.AccountsModel, model.SitesModel, model.AuthorizedSitesModel, model.DevicesModel, model.PatientSearchModel, model.InFormModel, model.UserProfileModel, model.DashboardModel, model.MenuIsDefaultCollapsed, model.MenuIsExpanded, model.S3Context, model.AwsToken, model.S3Configuration, model.Credentials), Cmd_none()];
                }
            }
        }
        case 3: {
            return [new Model(model.NotificationsModel, new Page(1, maybeCode), model.RedirectPage, model.AuthModel, new Model_2(model.TelepathologyGuestModel.telepathologyGuestTreeModel, maybeCode), model.UsersModel, model.AccountsModel, model.SitesModel, model.AuthorizedSitesModel, model.DevicesModel, model.PatientSearchModel, model.InFormModel, model.UserProfileModel, model.DashboardModel, model.MenuIsDefaultCollapsed, model.MenuIsExpanded, model.S3Context, model.AwsToken, model.S3Configuration, model.Credentials), Cmd_none()];
        }
        case 4: {
            return [(model_1 = (new Model(model.NotificationsModel, new Page(0, new AuthPage(0)), model.RedirectPage, model.AuthModel, model.TelepathologyGuestModel, model.UsersModel, model.AccountsModel, model.SitesModel, model.AuthorizedSitesModel, model.DevicesModel, model.PatientSearchModel, model.InFormModel, model.UserProfileModel, model.DashboardModel, model.MenuIsDefaultCollapsed, model.MenuIsExpanded, model.S3Context, model.AwsToken, model.S3Configuration, model.Credentials)), (nextPage != null) ? ((nextPage.tag === 0) ? ((nextPage.fields[0].tag === 0) ? model_1 : ((toConsole(printf("Navigating to Login, saving %O page for redirection"))(page_2), new Model(model_1.NotificationsModel, model_1.CurrentPage, nextPage, model_1.AuthModel, model_1.TelepathologyGuestModel, model_1.UsersModel, model_1.AccountsModel, model_1.SitesModel, model_1.AuthorizedSitesModel, model_1.DevicesModel, model_1.PatientSearchModel, model_1.InFormModel, model_1.UserProfileModel, model_1.DashboardModel, model_1.MenuIsDefaultCollapsed, model_1.MenuIsExpanded, model_1.S3Context, model_1.AwsToken, model_1.S3Configuration, model_1.Credentials)))) : ((toConsole(printf("Navigating to Login, saving %O page for redirection"))(page_2), new Model(model_1.NotificationsModel, model_1.CurrentPage, nextPage, model_1.AuthModel, model_1.TelepathologyGuestModel, model_1.UsersModel, model_1.AccountsModel, model_1.SitesModel, model_1.AuthorizedSitesModel, model_1.DevicesModel, model_1.PatientSearchModel, model_1.InFormModel, model_1.UserProfileModel, model_1.DashboardModel, model_1.MenuIsDefaultCollapsed, model_1.MenuIsExpanded, model_1.S3Context, model_1.AwsToken, model_1.S3Configuration, model_1.Credentials)))) : ((toConsole(printf("Navigating to Login, saving %O page for redirection"))(page_2), new Model(model_1.NotificationsModel, model_1.CurrentPage, nextPage, model_1.AuthModel, model_1.TelepathologyGuestModel, model_1.UsersModel, model_1.AccountsModel, model_1.SitesModel, model_1.AuthorizedSitesModel, model_1.DevicesModel, model_1.PatientSearchModel, model_1.InFormModel, model_1.UserProfileModel, model_1.DashboardModel, model_1.MenuIsDefaultCollapsed, model_1.MenuIsExpanded, model_1.S3Context, model_1.AwsToken, model_1.S3Configuration, model_1.Credentials)))), Navigation_modifyUrl(pageHash(new Page(0, new AuthPage(0))))];
        }
        case 5: {
            let pattern_matching_result_2, accountId_1, page_4;
            if (nextPage != null) {
                if (nextPage.tag === 3) {
                    if ((page_3 = nextPage, (accountId = nextPage.fields[0], model.AuthModel.UserInfo != null))) {
                        pattern_matching_result_2 = 0;
                        accountId_1 = nextPage.fields[0];
                        page_4 = nextPage;
                    }
                    else {
                        pattern_matching_result_2 = 1;
                    }
                }
                else {
                    pattern_matching_result_2 = 1;
                }
            }
            else {
                pattern_matching_result_2 = 1;
            }
            switch (pattern_matching_result_2) {
                case 0: {
                    const patternInput = init(accountId_1, model.AuthModel.UserInfo);
                    return [new Model(model.NotificationsModel, page_4, model.RedirectPage, model.AuthModel, model.TelepathologyGuestModel, model.UsersModel, model.AccountsModel, patternInput[0], model.AuthorizedSitesModel, model.DevicesModel, model.PatientSearchModel, model.InFormModel, model.UserProfileModel, model.DashboardModel, model.MenuIsDefaultCollapsed, model.MenuIsExpanded, model.S3Context, model.AwsToken, model.S3Configuration, model.Credentials), Cmd_batch(ofArray([Cmd_map((arg0_4) => (new Msg(5, arg0_4)), patternInput[1]), Navigation_newUrl(pageHash(page_4)), Cmd_OfFunc_result(new Msg(5, new Msg_1(1)))]))];
                }
                case 1: {
                    let pattern_matching_result_3, maybePatientId_1, maybeSessionId_1, page_6;
                    if (nextPage != null) {
                        if (nextPage.tag === 6) {
                            if ((page_5 = nextPage, (maybeSessionId = nextPage.fields[1], (maybePatientId = nextPage.fields[0], model.AuthModel.UserInfo != null)))) {
                                pattern_matching_result_3 = 0;
                                maybePatientId_1 = nextPage.fields[0];
                                maybeSessionId_1 = nextPage.fields[1];
                                page_6 = nextPage;
                            }
                            else {
                                pattern_matching_result_3 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_3 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_3 = 1;
                    }
                    switch (pattern_matching_result_3) {
                        case 0: {
                            const patternInput_1 = init_1(maybePatientId_1, maybeSessionId_1);
                            return [new Model(model.NotificationsModel, page_6, model.RedirectPage, model.AuthModel, model.TelepathologyGuestModel, model.UsersModel, model.AccountsModel, model.SitesModel, model.AuthorizedSitesModel, model.DevicesModel, patternInput_1[0], model.InFormModel, model.UserProfileModel, model.DashboardModel, model.MenuIsDefaultCollapsed, model.MenuIsExpanded, model.S3Context, model.AwsToken, model.S3Configuration, model.Credentials), Cmd_batch(ofArray([Cmd_map((arg0_6) => (new Msg(9, arg0_6)), patternInput_1[1]), Navigation_newUrl(pageHash(page_6)), Cmd_OfFunc_result(new Msg(9, new Msg_2(1)))]))];
                        }
                        case 1: {
                            let pattern_matching_result_4, page_8;
                            if (nextPage != null) {
                                if (nextPage.tag === 7) {
                                    if ((page_7 = nextPage, model.AuthModel.UserInfo != null)) {
                                        pattern_matching_result_4 = 0;
                                        page_8 = nextPage;
                                    }
                                    else {
                                        pattern_matching_result_4 = 1;
                                    }
                                }
                                else {
                                    pattern_matching_result_4 = 1;
                                }
                            }
                            else {
                                pattern_matching_result_4 = 1;
                            }
                            switch (pattern_matching_result_4) {
                                case 0: {
                                    const patternInput_2 = init_2();
                                    return [new Model(model.NotificationsModel, page_8, model.RedirectPage, model.AuthModel, model.TelepathologyGuestModel, model.UsersModel, model.AccountsModel, model.SitesModel, model.AuthorizedSitesModel, model.DevicesModel, model.PatientSearchModel, patternInput_2[0], model.UserProfileModel, model.DashboardModel, model.MenuIsDefaultCollapsed, model.MenuIsExpanded, model.S3Context, model.AwsToken, model.S3Configuration, model.Credentials), Cmd_batch(ofArray([Cmd_map((arg0_8) => (new Msg(10, arg0_8)), patternInput_2[1]), Navigation_newUrl(pageHash(page_8)), Cmd_OfFunc_result(new Msg(10, new Msg_3(1)))]))];
                                }
                                case 1: {
                                    if (nextPage != null) {
                                        const page_9 = nextPage;
                                        return [new Model(model.NotificationsModel, page_9, model.RedirectPage, model.AuthModel, model.TelepathologyGuestModel, model.UsersModel, model.AccountsModel, model.SitesModel, model.AuthorizedSitesModel, model.DevicesModel, model.PatientSearchModel, model.InFormModel, model.UserProfileModel, model.DashboardModel, model.MenuIsDefaultCollapsed, model.MenuIsExpanded, model.S3Context, model.AwsToken, model.S3Configuration, model.Credentials), Cmd_batch(singleton(Navigation_newUrl(pageHash(page_9))))];
                                    }
                                    else {
                                        throw (new Error("Match failure"));
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

